// src/sectors/pilates/settings/api/notificationsEmailApi.js
import { http } from 'shared/api/http';

const BASE = '/api/v1/pilates/notifications/email';

export const notificationsEmailApi = {
  checkMorningPlan: () => http(`${BASE}/check/morning-plan`, { method: 'GET', auth: true }),

  testMorningPlan: (payload) =>
    http(`${BASE}/test/morning-plan`, { method: 'POST', body: payload, auth: true }),
};
